import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useAuth } from './AuthContext';
import App from './App';
import { postLogin } from './apiService';
import { jwtDecode } from 'jwt-decode';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import Person4Icon from '@mui/icons-material/Person4';

const LoginForm = () => {
    const history = useHistory();
    const { isAuthenticated, login } = useAuth();
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [loginFailed, setLoginFailed] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [isAnimating, setIsAnimating] = useState(false);
    const [companyName, setCompanyName] = useState('');
    // const [companyId, setCompanyId] = useState('');
    //const [branchId, setBranchId] = useState('');
    const location = useLocation();

    const branchId = 1;
    const companyId = 1;
    
    useEffect(() => {
        setIsAnimating(true);
    }, []);


    const handleLogin = async () => {
        try {

            const jwtToken = await performLogin();
            const responseData = jwtDecode(jwtToken);
            const keysToRemove = ['iss', 'exp', 'ttp', 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name', 'aud'];
            const permissions = Object.keys(responseData).filter(
                (key) => key !== 'companyId' && key !== 'userId' && !keysToRemove.includes(key)
            );

            let isSuper = false;
            if (responseData.isSuperAdmin.toLowerCase() === "true") {
                isSuper = true;
            }

            if (isSuper == false) {
                const parsedCompanyId = parseInt(responseData.companyId, 10);

                if (parsedCompanyId === companyId) {
                    login(responseData.companyId, responseData.branchId, responseData.userId, isSuper, responseData.superAdminCompanyId, responseData.CompanyName, permissions, jwtToken, responseData.roleName, responseData.username);
                    const redirectParam = new URLSearchParams(location.search).get("redirect");
                    const redirectPath = redirectParam ? decodeURIComponent(redirectParam) : "/Home";
                    history.replace(redirectPath);
                }
                else {
                    toast.error('Invalid User !', {
                        position: "top-center",
                    });
                }
            }
            else {
                login(responseData.companyId, responseData.branchId, responseData.userId, isSuper, responseData.superAdminCompanyId, responseData.CompanyName, permissions, jwtToken, responseData.roleName, responseData.username);
                const redirectParam = new URLSearchParams(location.search).get("redirect");
                const redirectPath = redirectParam ? decodeURIComponent(redirectParam) : "/Home";
                history.replace(redirectPath);
            }


        } catch (error) {
            toast.error('Login failed', {
                position: "top-center",
            });
        }
    };

    const performLogin = async () => {
        const loginData = {
            UserName: username,
            Password: password,
            CompanyId: companyId,
            BranchId: branchId
        };

        const response = await postLogin('LoginApi', loginData);

        if (response.responseCode === '1111') {
            const jwtToken = response.response_data.token;

            return jwtToken;
        } else {
            throw new Error(response.Message);
        }
    };


    if (isAuthenticated) {
        return <App />;
    }

    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "100vh",
                backgroundSize: "cover",
            }}
        >
            <ToastContainer position="top-center" autoClose={3000} />

            <div
                style={{
                    width: "100%",
                    maxWidth: "400px",
                    padding: "30px",
                    borderRadius: "8px",
                    boxShadow: "0 8px 20px rgba(0, 0, 0, 0.2)",
                    backgroundImage: "linear-gradient(60deg, #2C2F48 0%, #2C2F48 100%)",
                    textAlign: "center",
                }}
            >
                <h2 style={{ fontSize: "28px", fontWeight: "700", marginBottom: "10px", color: "White" }}>
                    Login
                </h2>

                <form
                    onSubmit={(e) => {
                        e.preventDefault();
                        handleLogin();
                    }}
                >
                    <p style={{ fontSize: "16px", fontWeight: "500", marginBottom: "20px", color: "#FBF5E5" }}>
                        Welcome
                    </p>

                    {/* Username Field */}
                    <div style={{ position: "relative", marginBottom: "1.2rem" }}>
                        <span
                            style={{
                                position: "absolute",
                                left: "10px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                color: "#aaa",
                            }}
                        >
                            <Person4Icon />
                        </span>
                        <input
                            type="text"
                            placeholder="Enter Username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            style={{
                                width: "100%",
                                padding: "12px 10px 12px 35px",
                                borderRadius: "5px",
                                border: "1px solid #444",
                                background: "#2C2C3C",
                                color: "#fff",
                                outline: "none",
                            }}
                        />
                    </div>

                    {/* Password Field */}
                    <div style={{ position: "relative", marginBottom: "1.5rem" }}>
                        <span
                            style={{
                                position: "absolute",
                                left: "10px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                color: showPassword ? "red" : "white",
                                cursor: "pointer",
                            }}
                            onClick={() => setShowPassword((prev) => !prev)}
                        >
                            {showPassword ? <LockOpenIcon /> : <LockIcon />}
                        </span>
                        <input
                            type={showPassword ? "text" : "password"}
                            placeholder="Enter Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            style={{
                                width: "100%",
                                padding: "12px 10px 12px 35px",
                                borderRadius: "5px",
                                border: "1px solid #444",
                                background: "#2C2C3C",
                                color: "#fff",
                                outline: "none",
                            }}
                        />
                    </div>

                    {/* Login Button */}
                    <button
                        type="submit"
                        style={{
                            width: "100%",
                            padding: "12px",
                            borderRadius: "5px",
                            border: "none",
                            background: "#FF748B",
                            color: "#fff",
                            fontSize: "16px",
                            cursor: "pointer",
                            fontWeight: "600",
                        }}
                    >
                        Login
                    </button>
                </form>
            </div>
        </div>
    );
};

export default LoginForm;
